import { z } from 'zod';

import { EmblemSchema } from './identity';
import { IdSchema } from './common';
import { ActivityRefSchema } from './gathering';

/**
 * Таблица отрядов города (BLUEPRINT Stage 12, задача 2): серии полных составов и число
 * проведённых сборов. Людей в таблице нет — публичных рейтингов участников не бывает (3.3).
 */

export const CitySquadRowSchema = z.object({
  squadId: IdSchema,
  name: z.string().nullable(),
  emblem: EmblemSchema.nullable(),
  activity: ActivityRefSchema,
  weekday: z.number().int().min(1).max(7),
  startTime: z.string(),
  levelBand: z.number().int().min(1).max(5),
  capacity: z.number().int().positive(),
  /** Сборов проведено за всё время */
  gatheringsDone: z.number().int().nonnegative(),
  /** Сборов подряд полным составом */
  fullRosterStreak: z.number().int().nonnegative(),
  /** Лучшая серия полных составов за всё время */
  bestFullRosterStreak: z.number().int().nonnegative(),
  /** Сезонов сыграно (FINISHED) */
  seasonsDone: z.number().int().nonnegative(),
  /** Это мой отряд */
  isMine: z.boolean(),
});
export type CitySquadRow = z.infer<typeof CitySquadRowSchema>;

export const CityTableSchema = z.object({
  cityId: IdSchema,
  cityName: z.string(),
  squads: z.array(CitySquadRowSchema),
  /** Мой отряд в таблице (если есть) */
  mySquadId: IdSchema.nullable(),
});
export type CityTable = z.infer<typeof CityTableSchema>;

export const CityTableInputSchema = z
  .object({ cityId: IdSchema.optional(), activityId: IdSchema.optional() })
  .default({});
export type CityTableInput = z.infer<typeof CityTableInputSchema>;
